import { DefaultDParams } from "../shared/interfaces";
import { MonthlyClosure } from "./MonthlyClosure";
import { User } from "./User";

export interface MonthlyClosureDetail {

    id?: number;
    society?: string;
    monthly_closure?: MonthlyClosure;
    monthly_closure_id?: number;
    status?: string;
    created_user?: User;
    created_user_id?: number;
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;
}

export interface MonthlyClosureDetailDataForm {

    id?: number;
    society?: string;
    society_id?: number;
    monthly_closure?: string;
    monthly_closure_id?: number;
    created_user?: string;
    created_user_id?: number;
    status?: string;
    status_obj?: DefaultDParams;
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;
    statuses?: DefaultDParams[];
}

export const defaultMonthlyClosureDetailDataForm: MonthlyClosureDetailDataForm = {
};

export interface MonthlyClosureDetailFilters {
    id?: number | null;
    society?: string | '';
    worker?: string | '';
    status?: string | '';
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export interface MonthlyClosureDetailWorkerDataForm {

    id?: number;
    worker?: string;
    worker_id?: number;
    created_user?: string;
    created_user_id?: number;
    status?: string;
    status_obj?: DefaultDParams;
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;
    statuses?: DefaultDParams[];
}


